import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next"
import CurrencyInput from "react-currency-input-field"
import { PPDefaultSelector } from "../ui/PPDefaultSelector"

let options = [
    {
        locale: "de-DE",
        currency: "EUR"
    },
    {
        //Auch EUR um die englische Schreibweise mit . beizubehalten und Symbol €
        locale: "en-US",
        currency: "EUR"
    },
    {
        locale: "en-GB",
        currency: "GBP"
    },
    {
        locale: "ja-JP",
        currency: "JPY"
    },
    {
        locale: "en-IN",
        currency: "INR"
    }
]

function getAmazonShopIdsFromPreset(preset) {
    if (!preset?.shops?.length) {
        return []
    }
    return preset.shops
        .map((entry) => entry?.shop)
        .filter((shop) => shop?.name?.toLowerCase().includes("amazon"))
        .map((shop) => shop.id)
}

function PPPriceFilter(props) {
    const [t] = useTranslation()
    let addFilterBtnRef = useRef()

    const [intlConfig] = useState(options[1])
    const [valueMin, setValueMin] = useState("")
    const [valueMax, setValueMax] = useState("")
    const [rawValueMin, setRawValueMin] = useState(0)
    const [rawValueMax, setRawValueMax] = useState(-1)
    const [selectedFilterOption, setSelectedFilterOption] = useState(null)
    const [selectedBuyboxFilter, setSelectedBuyboxFilter] = useState(null)

    const amazonShopIds = getAmazonShopIdsFromPreset(props.preset)
    const showBuyboxFilter = amazonShopIds.length > 0

    const handleOnValueChangeMin = (value) => {
        setRawValueMin(value === undefined ? 0 : value || 0)
        setValueMin(value)
    }

    const handleOnValueChangeMax = (value) => {
        setRawValueMax(value === undefined ? -1 : value || -1)
        setValueMax(value)
    }

    function hasPriceInput() {
        return (valueMin !== "" && valueMin != null) || (valueMax !== "" && valueMax != null)
    }

    function filterPricetableData() {
        const buyboxFilter = showBuyboxFilter ? selectedBuyboxFilter : null
        const priceActive = hasPriceInput()

        if (!priceActive && !buyboxFilter) {
            props.handleSort(null, null)
            return
        }

        let sortObject = {
            propertyName: "priceRange",
            minPrice: priceActive && valueMin !== "" && valueMin != null ? rawValueMin : -1,
            maxPrice: priceActive && valueMax !== "" && valueMax != null ? rawValueMax : -1,
            amazonBuyboxFilter: buyboxFilter || null,
            amazonBuyboxShopIds: buyboxFilter ? amazonShopIds : null
        }
        let sortOption = selectedFilterOption
        props.handleSort(sortObject, sortOption)
    }

    function prepareFilterOptionOptions() {
        return [
            {
                value: "ASC",
                label: t("single.asc")
            },
            {
                value: "DESC",
                label: t("single.desc")
            }
        ]
    }

    function prepareBuyboxFilterOptions() {
        return [
            {
                value: "HAS",
                label: t("price_filter.buybox_has")
            },
            {
                value: "NONE",
                label: t("price_filter.buybox_none")
            },
            {
                value: "UNKNOWN",
                label: t("price_filter.buybox_unknown")
            }
        ]
    }

    useEffect(() => {
        if (rawValueMax != -1 && Math.abs(parseFloat(rawValueMax)) < Math.abs(parseFloat(rawValueMin))) {
            addFilterBtnRef.current.setAttribute("disabled", true)
            addFilterBtnRef.current.setAttribute("title", "Min > Max!")
        } else {
            addFilterBtnRef.current.removeAttribute("disabled")
            addFilterBtnRef.current.removeAttribute("title")
        }
    }, [rawValueMax, rawValueMin])

    return (
        <div>
            <div className="row">
                <div className="col-1">
                    <CurrencyInput
                        id="validationCustom01"
                        name="input-1"
                        intlConfig={intlConfig}
                        className={`form-control`}
                        onValueChange={handleOnValueChangeMin}
                        decimalsLimit={6}
                        allowNegativeValue={false}
                        value={valueMin}
                        step={1}
                        placeholder={"Min"}
                    />
                </div>
                <div className="col-1">
                    <CurrencyInput
                        id="validationCustom02"
                        name="input-2"
                        intlConfig={intlConfig}
                        className={`form-control`}
                        onValueChange={handleOnValueChangeMax}
                        decimalsLimit={6}
                        allowNegativeValue={false}
                        value={valueMax}
                        step={1}
                        placeholder={"Max"}
                    />
                </div>
                <div className="col-2">
                    <PPDefaultSelector
                        id="selectPricetableFilterShopOption"
                        data={prepareFilterOptionOptions()}
                        name="FilterOptions"
                        placeholder={t("shop_filter.filter_options")}
                        onChange={(e) => setSelectedFilterOption(e?.value)}
                        isClearable={false}
                        value={
                            selectedFilterOption != null ? selectedFilterOption.value : prepareFilterOptionOptions()[0]
                        }
                    />
                </div>
                <div className="col-auto">
                    <button
                        id="buttonPricetableFilterPriceApplyFilter"
                        className="category-button-go btn btn-primary"
                        type="button"
                        ref={addFilterBtnRef}
                        onClick={filterPricetableData}>
                        {t("single.apply_filter")}
                    </button>
                </div>
            </div>
            {showBuyboxFilter && (
                <div className="row mt-2">
                    <div className="col-3 pp-price-filter-buybox">
                        <PPDefaultSelector
                            id="selectPricetableFilterAmazonBuybox"
                            data={prepareBuyboxFilterOptions()}
                            name="AmazonBuyboxFilter"
                            placeholder={t("price_filter.buybox_placeholder")}
                            onChange={(e) => setSelectedBuyboxFilter(e?.value ?? null)}
                            isClearable={true}
                            value={
                                selectedBuyboxFilter != null
                                    ? prepareBuyboxFilterOptions().find((o) => o.value === selectedBuyboxFilter)
                                    : null
                            }
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default PPPriceFilter
